var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuscleBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.113,
    height: 29.115,
    viewBox: "0 0 28.113 29.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752",
    transform: "translate(-255.632 4.815)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    "data-name": "Group 1751",
    transform: "translate(255.514 -4.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    d: "M284.016,29.766A13.343,13.343,0,0,1,276.7,28.4a.473.473,0,0,0-.361-.046c-.051.014-5.163,1.384-9.279.47-2.566-.571-4.987-2.378-6.754-3.7-.238-.177-.462-.345-.673-.5a5.394,5.394,0,0,0-1.152-.541c-.182-.07-.431-.165-.484-.2a.185.185,0,0,1-.072-.15v-1.1c.023-.872,3.678-14.287,4.245-15.994a.369.369,0,0,1,.109-.079l7.235-3.3L271.851,6.3a.419.419,0,0,1-.026.524l-2.311,2.591a.412.412,0,0,1-.564.056l-.934-.861A.478.478,0,0,0,267.6,8.5a.5.5,0,0,0-.345.263,2.6,2.6,0,0,1-1.507.347l-.235-.024a.471.471,0,0,0-.464.242.476.476,0,0,0,.039.521c.2.26.357.468.446.587L266,18.3a3.461,3.461,0,0,1-.615,1.5.475.475,0,0,0,.143.929c.539,0,1-.709,1.365-2.091a5.816,5.816,0,0,1,7.339.06,3.76,3.76,0,0,1,1.278,2.041.475.475,0,0,0,.951-.01,3.97,3.97,0,0,0-1.27-2.4,6.063,6.063,0,0,1,3.936-2.427,6.9,6.9,0,0,1,4.639,1.395.475.475,0,0,0,.6-.736,7.753,7.753,0,0,0-5.346-1.6,6.948,6.948,0,0,0-4.551,2.74,6.757,6.757,0,0,0-7.567-.221l-.426-7.231a.471.471,0,0,0-.069-.22,3.12,3.12,0,0,0,1.3-.4l.613.564a1.362,1.362,0,0,0,1.9-.137l2.311-2.591a1.378,1.378,0,0,0,.077-1.727l-2.576-3.354a.476.476,0,0,0-.575-.143l-7.572,3.459a1.155,1.155,0,0,0-.613.626c-.269.808-4.3,15.192-4.3,16.312v1.1a1.134,1.134,0,0,0,.436.9,3.009,3.009,0,0,0,.73.338,5.169,5.169,0,0,1,.93.421c.209.153.431.319.666.494,1.836,1.372,4.351,3.25,7.117,3.865a23.256,23.256,0,0,0,9.549-.432,14.25,14.25,0,0,0,6.266,1.471,13.115,13.115,0,0,0,1.453-.08.475.475,0,1,0-.105-.944Zm0,0",
    transform: "translate(-256.605 -1.86)",
    fill: "#1c9d87",
    stroke: "#1c9d87",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M675.8,378.7a.475.475,0,0,0-.948.052c0,.317.234,1.393,3.249,1.895a.5.5,0,0,0,.079.006.475.475,0,0,0,.078-.944c-2.109-.351-2.43-.946-2.458-1.01Zm0,0",
    transform: "translate(-650.717 -356.559)",
    fill: "#1c9d87",
    stroke: "#1c9d87",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M367.144,373.266c-6.226,1.333-8.89-2.926-9-3.108a.475.475,0,0,0-.815.49A8.156,8.156,0,0,0,359.734,373a9.217,9.217,0,0,0,5.112,1.471,11.909,11.909,0,0,0,2.5-.275.475.475,0,0,0-.2-.93Zm0,0",
    transform: "translate(-95.675 -353.56)",
    fill: "#1c9d87",
    stroke: "#1c9d87",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscleBuilding);
export default __webpack_public_path__ + "static/media/muscleBuilding.1fbaf7312f423f1f97cab39b984e6149.svg";
export { ForwardRef as ReactComponent };